const classroomsURL = process.env.VUE_APP_CLASSROOMS_URL;
const chimeraURL = process.env.VUE_APP_CHIMERA_URL;
const dexGraphqlURL = process.env.VUE_APP_DEX_GRAPHQL_URL;
const dexAuthenticationURL = process.env.VUE_APP_DEX_AUTHENTICATION_URL;
const descomplicaAuthenticationURL = process.env.VUE_APP_DESCOMPLICA_AUTHENTICATION_URL;
const passepartoutURL = process.env.VUE_APP_PASSEPARTOUT_URL;
const forumURL = process.env.VUE_APP_GRAPH_CMS_FORUM_URL;
const pearsonURL = process.env.VUE_APP_PEARSON_URL;
const lyceumAuthenticationUrl = process.env.VUE_APP_LYCEUM_AUTHENTICATION_URL;
const westerosGraphqlURL = {
  CROW_ENDPOINT: process.env.VUE_APP_WESTEROS_CROW_GRAPHQL,
  CROW_WS_ENDPOINT: process.env.VUE_APP_WESTEROS_CROW_GRAPHQL_WS,
  REACTION_ENDPOINT: process.env.VUE_APP_WESTEROS_REACTIONS_GRAPHQL,
  PROFILE_ENDPOINT: process.env.VUE_APP_WESTEROS_PROFILE_GRAPHQL,
  MICROCERTIFICATES_ENDPOINT: process.env.VUE_APP_WESTEROS_MICROCERTIFICATES_GRAPHQL,
  ENROLLMENTS_ENDPOINT: process.env.VUE_APP_WESTEROS_ENROLLMENTS_GRAPHQL,
  STUDENTNOTES_ENDPOINT: process.env.VUE_APP_WESTEROS_STUDENTNOTES_GRAPHQL,
  KINGSLANDING_ENDPOINT: process.env.VUE_APP_WESTEROS_KINGSLANDING_GRAPHQL,
};

const fileUploadURL = process.env.VUE_APP_FILE_UPLOAD_URL;
const lapURL = process.env.VUE_APP_LAP_URL;
const postBackofficeAdminURL = process.env.VUE_APP_POST_BACKOFFICE_ADMIN_URL;
const alumniURL = process.env.VUE_APP_ALUMNI_URL;
const termsOfUseURL = process.env.VUE_APP_USE_TERMS_OF_USE_ENDPOINT_URL;
const pegasusMustangBaseUrl = process.env.VUE_APP_MUSTANG_BASE_URL;
const boardsGroupsUrl = process.env.VUE_APP_POSTGRAD_BOARDS_GROUPS_URL;

const pegasusPepeLegalUrl = {
  UNDERGRAD: process.env.VUE_APP_PEPE_LEGAL_UNDERGRAD_URL,
};

const appGatherTownUrl = process.env.VUE_APP_GATHER_TOWN_URL;
const pegasusEponaUrl = process.env.VUE_APP_EPONA_UNDERGRAD_ANALYTICS_URL;

const jacadUrl = process.env.VUE_APP_JACAD_URL;
const linkedinUrl = process.env.VUE_APP_LINKEDIN_URL;
const linkedinOAuthUrl = process.env.VUE_APP_LINKEDIN_OAUTH_URL;

const postgradAssessmentsUrl = process.env.VUE_APP_POSTGRAD_ASSESSMENTS_GRAPHQL;
const postgradStudyPlanningUrl = process.env.VUE_APP_POSTGRAD_STUDYPLANNING_GRAPHQL;

export const ENDPOINTS = {
  boardsgroups: boardsGroupsUrl,
  classrooms: classroomsURL,
  chimera: chimeraURL,
  dexGraphql: dexGraphqlURL,
  dexAuthentication: dexAuthenticationURL,
  descomplicaAuthentication: descomplicaAuthenticationURL,
  passepartout: passepartoutURL,
  forum: forumURL,
  pearson: pearsonURL,
  lyceumAuthentication: lyceumAuthenticationUrl,
  westerosGraphql: westerosGraphqlURL,
  fileUpload: fileUploadURL,
  lap: lapURL,
  postBackofficeAdmin: postBackofficeAdminURL,
  alumni: alumniURL,
  termsOfUse: termsOfUseURL,
  pegasusMustang: pegasusMustangBaseUrl,
  pegasusPepeLegal: pegasusPepeLegalUrl,
  appGatherTown: appGatherTownUrl,
  pegasusEpona: pegasusEponaUrl,
  jacad: jacadUrl,
  linkedin: linkedinUrl,
  linkedinOAuth: linkedinOAuthUrl,
  postgradAssessments: postgradAssessmentsUrl,
  postgradStudyPlanning: postgradStudyPlanningUrl,
};
